var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignPrettify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5H3M21 9.5H3M3 16.9964L5.7579 14.4927M3 16.9964L5.7579 19.5M3 16.9964H16.5907C18.1341 16.9964 18.9058 16.9964 19.4953 16.729C20.0138 16.4939 20.4354 16.1187 20.6996 15.6572C21 15.1326 21 14.4458 21 13.0723V12.5",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignPrettify);
export default __webpack_public_path__ + "static/media/align-prettify.087e2becdc133a60f812c7ca9598f571.svg";
export { ForwardRef as ReactComponent };